(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const quantityWrappers = document.querySelectorAll(
      '[data-quantity-wrapper].pdp-main-product-qty'
    );

    const errorMessage = document.getElementById(
      'stock-error-message'
    );

    function getPopupErrorMessage() {
      return document.getElementById(
        'stock-error-message-popup'
      );
    }

    function parseQuantity(value, fallback = 0) {
      const parsed = parseInt(value, 10);

      return Number.isFinite(parsed)
        ? parsed
        : fallback;
    }

    function clearError() {
      if (errorMessage) {
        errorMessage.textContent = '';
        errorMessage.style.display = 'none';
      }

      const popupErrorMessage =
        getPopupErrorMessage();

      if (popupErrorMessage) {
        popupErrorMessage.textContent = '';
        popupErrorMessage.style.display = 'none';
      }
    }

    function showError(text) {
      if (errorMessage) {
        errorMessage.textContent = text;
        errorMessage.style.display = '';
      }

      const popupErrorMessage =
        getPopupErrorMessage();

      if (popupErrorMessage) {
        popupErrorMessage.textContent = text;
        popupErrorMessage.style.display = '';
      }
    }

    function getQuantityState(input) {
      const inventoryManaged = Boolean(
        input.dataset.inventorymgmt?.trim()
      );

      const available = Math.max(
        0,
        parseQuantity(
          input.dataset.available,
          0
        )
      );

      const cartQuantity = Math.max(
        0,
        parseQuantity(
          input.dataset.cartQty,
          0
        )
      );

      const availableStock = Math.max(
        0,
        parseQuantity(
          input.dataset.availablestock,
          0
        )
      );

      const minimum = Math.max(
        1,
        parseQuantity(
          input.getAttribute('min'),
          1
        )
      );

      const current = Math.max(
        minimum,
        parseQuantity(
          input.value,
          minimum
        )
      );

      const cartReachedMaximum =
        inventoryManaged &&
        availableStock !== 0 &&
        cartQuantity >= availableStock;

      const inputReachedMaximum =
        inventoryManaged &&
        availableStock !== 0 &&
        current >= available;

      return {
        inventoryManaged,
        available,
        cartQuantity,
        availableStock,
        minimum,
        current,
        cartReachedMaximum,
        inputReachedMaximum,
        atMaximum:
          cartReachedMaximum ||
          inputReachedMaximum
      };
    }

    function syncHiddenQuantityInput(input) {
      const hiddenQuantityInput = input
        .closest('.product-quantity-with-buy')
        ?.querySelector(
          '.hidden-quantity-input'
        );

      if (hiddenQuantityInput) {
        hiddenQuantityInput.value =
          input.value;
      }
    }

    /*
     * Works out what the error message SHOULD say right now,
     * purely from cart/inventory state. Returns null when no
     * message should be showing.
     */
    function getExpectedErrorMessage(state) {
      if (!state.inventoryManaged) {
        return null;
      }

      if (state.cartReachedMaximum) {
        return 'The maximum quantity of this item is already in your basket.';
      }

      if (
        state.availableStock !== 0 &&
        state.current > state.available
      ) {
        return `Only ${state.available} items can be added due to availability.`;
      }

      return null;
    }

    /*
     * Two modes:
     *
     * - recompute: true (used after cart:quantity-attribute-updated,
     *   i.e. real backend truth arriving from add-to-cart, drawer
     *   removals, other-tab changes, etc). Fully re-derives the
     *   correct message and shows/clears it to match, even if no
     *   error was showing before.
     *
     * - recompute: false / default (used by the typing/click
     *   handlers below, which already set their own message right
     *   before calling updateWrapper). This only ever clears a
     *   stale message; it never shows a new one on its own, so it
     *   can't stomp on a message the handler just set.
     */
    function syncErrorMessage(state, { recompute = false } = {}) {
      if (recompute) {
        const expected = getExpectedErrorMessage(state);

        if (expected) {
          showError(expected);
        } else {
          clearError();
        }

        return;
      }

      if (!state.inventoryManaged || !state.atMaximum) {
        clearError();
      }
    }

    function updateWrapper(wrapper, options = {}) {
      const input = wrapper.querySelector(
        '[data-quantity-input]'
      );

      const plusButton = wrapper.querySelector(
        '[data-quantity-increment]'
      );

      const minusButton = wrapper.querySelector(
        '[data-quantity-decrement]'
      );

      if (!input || !plusButton) return;

      const state = getQuantityState(input);

      syncErrorMessage(state, options);

      if (!state.inventoryManaged) {
        plusButton.classList.remove(
          'disabled-minus'
        );

        plusButton.removeAttribute(
          'disabled'
        );

        plusButton.removeAttribute(
          'aria-disabled'
        );

        syncHiddenQuantityInput(input);

        return;
      }

      /*
       * Add only the class at the maximum.
       * Do not add the native disabled attribute.
       */
      plusButton.classList.toggle(
        'disabled-minus',
        state.atMaximum
      );

      plusButton.removeAttribute(
        'disabled'
      );

      plusButton.removeAttribute(
        'aria-disabled'
      );

      if (minusButton) {
        minusButton.classList.toggle(
          'disabled-minus',
          state.current <= state.minimum
        );

        minusButton.removeAttribute(
          'disabled'
        );

        minusButton.removeAttribute(
          'aria-disabled'
        );

        minusButton.removeAttribute(
          'tabindex'
        );
      }

      syncHiddenQuantityInput(input);
    }

    function updateAllWrappers(options = {}) {
      quantityWrappers.forEach(
        (wrapper) => updateWrapper(wrapper, options)
      );
    }

    quantityWrappers.forEach((wrapper) => {
      const input = wrapper.querySelector(
        '[data-quantity-input]'
      );

      const plusButton = wrapper.querySelector(
        '[data-quantity-increment]'
      );

      const minusButton = wrapper.querySelector(
        '[data-quantity-decrement]'
      );

      if (!input || !plusButton) return;

      /*
       * Show the error when the customer clicks plus
       * while already at the maximum.
       */
      plusButton.addEventListener(
        'click',
        function (event) {
          const state =
            getQuantityState(input);

          if (!state.inventoryManaged) {
            clearError();
            return;
          }

          if (!state.atMaximum) {
            clearError();

            window.setTimeout(() => {
              updateWrapper(wrapper);
            }, 0);

            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();

          if (state.cartReachedMaximum) {
            showError(
              'The maximum quantity of this item is already in your basket.'
            );

            return;
          }

          showError(
            `Only ${state.available} items can be added due to availability.`
          );
        },
        true
      );

      /*
       * Detect typing, pasting or using the native
       * number-input controls.
       *
       * Entering the exact maximum does not show an error.
       * Entering more than the maximum shows an error.
       */
      input.addEventListener(
        'input',
        function () {
          const state =
            getQuantityState(input);

          const enteredQuantity =
            parseQuantity(
              input.value,
              state.minimum
            );

          if (
            enteredQuantity <
            state.minimum
          ) {
            input.value = String(
              state.minimum
            );

            clearError();
            updateWrapper(wrapper);
            return;
          }

          if (!state.inventoryManaged) {
            clearError();
            updateWrapper(wrapper);
            return;
          }

          /*
           * All available stock is already in the cart.
           */
          if (
            state.cartReachedMaximum &&
            enteredQuantity >
              state.minimum
          ) {
            input.value = String(
              state.minimum
            );

            showError(
              'The maximum quantity of this item is already in your basket.'
            );

            updateWrapper(wrapper);
            return;
          }

          /*
           * Allow the exact maximum.
           * Show the error only when it is exceeded.
           */
          if (
            state.availableStock !== 0 &&
            enteredQuantity >
              state.available
          ) {
            input.value = String(
              Math.max(
                state.minimum,
                state.available
              )
            );

            showError(
              `Only ${state.available} items can be added due to availability.`
            );

            updateWrapper(wrapper);
            return;
          }

          clearError();
          updateWrapper(wrapper);
        }
      );

      /*
       * Prevent invalid characters and detect an
       * Arrow Up attempt while already at maximum.
       */
      input.addEventListener(
        'keydown',
        function (event) {
          if (
            ['e', 'E', '+', '-'].includes(
              event.key
            )
          ) {
            event.preventDefault();
            return;
          }

          if (event.key !== 'ArrowUp') {
            return;
          }

          const state =
            getQuantityState(input);

          if (
            !state.inventoryManaged ||
            !state.atMaximum
          ) {
            return;
          }

          event.preventDefault();

          if (state.cartReachedMaximum) {
            showError(
              'The maximum quantity of this item is already in your basket.'
            );

            return;
          }

          showError(
            `Only ${state.available} items can be added due to availability.`
          );
        }
      );

      if (minusButton) {
        minusButton.addEventListener(
          'click',
          function () {
            clearError();

            window.setTimeout(() => {
              updateWrapper(wrapper);
            }, 0);
          }
        );
      }
    });

    /*
     * Resynchronize when cart quantity attributes are updated by
     * the cart synchronization script (add-to-cart succeeding,
     * drawer removals/updates, other-tab changes, etc). This is
     * real backend truth, so fully recompute the message rather
     * than only clearing it.
     */
    document.addEventListener(
      'cart:quantity-attribute-updated',
      () => updateAllWrappers({ recompute: true })
    );

    updateAllWrappers();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-custom-category-section"] && !Shopify.designMode) return;
  try {
    

  const subMenuExist = document.querySelector('[data-submenu]')
  if(subMenuExist && subMenuExist.dataset.submenu){
    document.body.classList.add('parent-category')
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const applyAccordionState = () => {
        const showAccordionOnMobile =
          document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        document.querySelectorAll('details[data-accordion]').forEach((el) => {
          if (showAccordionOnMobile && isMobile) {
            // Show accordion on mobile if setting allows
            el.removeAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','false');
          } else if (!showAccordionOnMobile && isMobile) {
            // Do not show accordion on mobile if setting disallows
           // el.setAttribute('open');
          } else if (!isMobile) {
            // On desktop, always open accordions
            el.setAttribute('open', '');
            document.querySelector('[data-show-accordion]').setAttribute('data-show-accordion','true');
          }
        });
      };
      applyAccordionState();
      window.addEventListener('resize', applyAccordionState);
      document.addEventListener('shopify:section:load', (event) => {
        // Apply accordion state when a new section is loaded
        applyAccordionState();
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
